

export const Translate = (key) => {
    if (window.__nibe.translation == null) {
        window.__nibe.translation = {};
    }

    return window.__nibe.translation[key] || key;
};
